module.exports = __webpack_public_path__ + "img/nu.e4ceabc3.svg";